export default __webpack_public_path__ + "static/media/78.6745ad41.png";